export default{
  // 公共的
  pub:{
    notLoad: "无法加载",
    sysYc: "系统异常",
    keyword: "关键字",
    del: "删除",
    delSure: "删除确认",
    delSc: "删除成功",
    cancel: "取消",
    sure: "确定",
    copy: "复制",
    copyOk: "复制成功",
    browserNotCopy: "该浏览器不支持自动复制",
    save: "保存",
    saveOk: "保存成功",
    operation: "操作",
    preview: "预览",
    edit: "编辑",
    ss: "秒",
    mm: "分",
    hour: "小时",
    beginTime: "开始时间",
    endTime: "结束时间",

    uploadFail: "上传失败",
    uploadFailYy: "上传失败的原因",
    more: "更多",
    submit: "提交",
    operationSc: "操作成功",
    close: "关闭",
    xuhao: "序号",
    leixing: "类型",
    issureOperation: "您确认要进行此操作吗",
    queren: "确认",
    error: "错误",
    chooseAll: "全选"
  },
  // 外框架 app.vue
  index:{
    homepage: "主页",
    usercenter: "用户中心",
    guideControl: "导播管控",
    exit: "退出",
    cloudLive: "云直播",
    cloudDemand: "云点播",
    cloudProd: "云制作",
    videoMs: "视频微站",
    livematches: "赛事直播",
    gkSearch: "概况查询",
  },
  // 主页
  home:{
    overview:{
      videoTotal: "视频总计",
      nums: "个",
      liveBroadcast: "直播活动",
      currentAccount: "当前账户剩余",
      useParentTenant: "使用父租户套餐",
      storage: "存储",
      notOpencc: "未开通存储功能",
      lineTime: "连线时长",
      notOpenLine: "未开通连线功能",
      latelyUploadVideo: "最近上传视频",
      nowDay: "今日",
      sevenDay: "最近7天",
      mores: "更多",
      notLoad: "无法加载",
      preview: "预览",
      address: "地址",
      videoName: "视频名称",
      uploadTime: "上传时间",
      noVideoContent: "暂无视频内容",
      liveChannel: "直播中通道",
      totalChannel: "通道总计",
      living: "直播中",
      channelName: "通道名称",
      createTime: "创建时间",
      notLiveChannel: "暂无直播中通道",
      cloudYy: "云应用",
      useGuide: "启用云导播",
      platform: "台",
      newLineRoom: "实时连线房间",
      onlinePs: "连线在线人数",
      openDp: "打开大屏",
      openYysjdp: "视频运营数据大屏",
      browserNotUse: "您的浏览器不支持。",
      mm: "分钟",
      yy: "年",
      site: "场",
      yh: "原画",
      sysYc: "系统异常",
      videoAddress: "视频地址",
      copy: "复制",
      downLoad: "下载",
      cancel: "取消",
      sure: "确定",
      copyOk: "复制成功",
      browserNotCopy: "该浏览器不支持自动复制",
      channelAddress: "通道地址",
      pushAddress: "推流地址",
      bfAddress: "播放地址",
      sourceCode: "源码",
      // bigScreen
      overviewPreview:"概况预览",
      thisMouthLive: "本月直播活动",
      ended: "已结束",
      activityName: "活动名称",
      cloudCutVideo: "云剪辑生产视频",
      // bigScreen2
      dataAnalysis: "视频运营数据分析",
      lookDate: "查看日历",
      month: "月",
      monthLive: "月度直播次数",
      videoPlayNum: "视频播放量",
      live: "直播",
      onDemand: "点播",
      liveviewingTrend: "直播观看趋势",
      viewNum: "每月观看人数",
      yxViewNum: "每月有效观看人数",
      videoTimeFb: "视频时长分布",
      areaViewFb: "全国观看地区分布",
      province: "省份",
      video: "视频",
      niandu: "年度",
      thisMonth: "本月",
      yesterday: "昨天",
      day: "日",
      noData: "无数据",
      liveNum: "直播次数",
      liveTimes: "直播播放时长",
      videoPlayNum: "视频播放次数",
      videoNum: "视频数量",
      zhejiang: "浙江",
      qinghai: "青海",
      jiangsu: "江苏",
      xiagjiang: "新疆",
      hainan: "海南",
      taiwan: "台湾",
      hebei: "河北",
      heilongjiang: "黑龙江",
      ningxia: "宁夏",
      chongqing: "重庆",
      fujian: "福建",
      hunan: "湖南",
      watchPs: "观看人次",
    },
  },
  // 通道管理
  live:{
    liveLine: "直播连线",
    channel:{
      channelManage: "通道管理",
      keyword: "关键字",
      newChannel: "新建通道",
      channelName: "通道名称",
      createTime: "创建时间",
      status: "状态",
      channelType: "通道类型",
      openClose: "开启/关闭",
      edit: "操作",
      manage: "管理",
      address: "地址",
      preview: "预览",
      topush: "转推",
      monitor: "监控",
      del: "删除",
      addRecordTask: "添加录制任务",
      notLoad: "无法加载",
      notChannel: "暂无通道，快去新建吧～",
      nopoint: "暂无输入",
      pushAddress: "推流地址",
      bfAddress: "播放地址",
      copy: "复制",
      sourceCode: "源码",
      cancel: "取消",
      sure: "确定",
      cloudHomePage: "云直播主页",
      pushFlow: "推流",
      pullFlow: "拉流",
      notknow: "未知",
      noLiveStream: "无直播流",
      living: "直播中",
      closed: "已关闭",
      pulling: "拉流中",
      pullFailed: "拉流失败",
      waitPull: "等待拉流",
      pouse: "暂停",
      openChannel: "开启通道成功",
      closeChannel: "关闭通道成功",
      sysYc: "系统异常",
      cancelEdit: "操作已取消",
      isSureOpenChannel: "确认开启通道吗",
      isSureCloseChannel: "确认关闭通道吗",
      editSure: "操作确认",
      copyOk: "复制成功",
      browserNotCopy: "该浏览器不支持自动复制",
      delChannel: "删除通道成功",
      delSure: "删除确认",
      isSureDelChannel: "你确认要删除通道吗",
      resetSc: "重试成功",
      yh: "原画",
      // addRecordTaskModal
      saveTask: "保存录制任务",
      recordChannel: "录制通道",
      chooseChannel: "选择通道",
      taskName: "任务名称",
      maxWordst: "最多30个字符",
      recordTime: "录制时间",
      beginTime: "开始时间",
      arrive: "至",
      endTime: "结束时间",
      saveOk: "保存成功",
      channelNotNull: "录制通道不能为空",
      channelNameNotNull: "录制名称不能为空",
      chnnMaxword: "录制名称最多30个字符",
      timeMush: "录制开始时间和录制结束时间都是必填字段",
      endtimeDyBegintime: "录制结束时间必须大于录制开始时间",
      ftTime: "开始时间不得早于当前时间48小时",
      sixTime: "开始、结束时间间隔不得超过6小时",
      xhhj: "信号汇聚",
      xhdd: "信号调度",
      xhjk: "信号监控",
      //distribution
      ffptMng: "分发平台管理",
      ffPlatform: "分发平台",
      ffAddress: "分发地址",
      newPlatfrom: "新建分发平台",
      ffIng: "分发中",
      ldle: "闲置",
      newPt: "新建平台",
      editPt: "编辑平台",
      isSureDelPt: "你确定要删除分发平台吗",
      plsIptName: "请输入分发平台",
      plaIptAds: "请输入分发地址",
      namePtNotNull: "分发平台和分发地址不能为空",
      // channelbuilt
      chooseLiveType: "选择直播方式",
      basicInfo: "基础信息",
      isClip: "是否支持实时剪辑",
      isAnalysis: "是否开启智能分析",
      isSnapshot: "是否开启实时截图",
      isPorn: "是否开启智能鉴别",
      pullInfo: "拉流配置信息",
      advancesSetup: "高级配置",
      hlsDelayTime: "延时直播",
      ss: "秒",
      logoId: "直播水印",
      chooseLogo: "选择水印",
      newLoge: "新建水印",
      xgLiveAdress: "修改直播水印会刷新推流地址，修改后请使用最新地址进行推流",
      nowZm: "实时转码",
      name: "名称",
      mlkbps: "码率kbps",
      resolePower: "分辨率",
      mljfOne: "此码率计入直播转码计费，1分钟转码扣100M直播流量",
      mljfTwo: "此码率计入直播转码计费，1分钟转码扣200M直播流量",
      selfAdaption: "自适应",
      mljfK: "此码率计入直播转码计费，1分钟转码扣1000M直播流量",
      outputProtocolsArr: "播放协议",
      save: "保存",
      minOneMl: "至少选择一种码率",
      halfHour: "半小时",
      oneHour: "1小时",
      tyHour: "24小时",
      selfSet: "自定义",
      pointChannelName: "请输入通道名称",
      twoToTy: "2到26个字符",
      minOneXy: "至少选择一种协议",
      editChannel: "修改通道",
      saveChannelOk: "保存通道成功",
      issaveOk:"保存确认",
      isSaveChannel: "你确认要保存通道吗",
      pealseChooseLoge: "请选择水印后预览",
      // addWatermarkModal 新建水印
      logoSet: "水印设置",
      logoName: "水印名称",
      pointName: "输入名称",
      logoImg: "水印图片",
      logoShouldType: "注意：为了最佳视觉效果，水印应为透明图片png或jpg格式",
      imgMaxOne: "图片大小不能大于1MB",
      showPosition: "显示位置",
      axis: "轴",
      logoSize: "水印尺寸",
      width: "宽",
      height: "高",
      logoNameNotNull: "水印名称不能为空",
      addLogeImg: "请添加水印图片",
      logeNameLong: "水印名称过长",
      // materialListModal2 选择图片
      chooseImg: "选择图片",
      chooseBdImg: "选择本地图片",
      imgMaxOne: "图片大小不得超过1M",
      plsChooseImg: "请选择图片",
      imgTypeErr: "上传图片格式有误，请重新上传",
      uploadImgMaxOne: "上传图片大小不得超过1M",
      uploadSc: "上传成功",
      uploadFil: "上传图片失败",
      // previewWatermarkModal
      logoPreview: "水印预览",
      // PullVodPushLive
      livePullAddress: "直播拉流地址",
      chooseVideoFile: "选择视频文件",
      pullAddress: "拉流地址",
      pullAddressTYpe: "拉流地址支持rtmp、hls、flv、rstp格式",
      dbFile: "点播文件",
      chooseDbFile: "请选择点播文件",
      chooseDb: "选择点播",
      playType: "播放方式",
      sxPlay: "顺序播放",
      liXh: "列表循环",
      mustLargeNow: "必须大于当前时间",
      mustLargeBegin: "必须大于开始时间",
      sureHasZbl: "请确保改时间段内有稳定直播流",
      pointPullAddress: "请输入拉流地址",
      pullAdErr: "拉流地址格式错误",
      chooseTime: "请选择时、分",
      endTimeBigBeginTime: "结束时间必须大于开始时间",
      timeJg: "结束时间 和 开始时间 间隔必须小于",
      hour: "小时",
      bgtSmallEdt: "开始时间必须小于结束时间",
      chooseBgt: "请选择开始时间",
      choosePlayType: "请选择播放方式",
      chooseEdt: "请选择结束时间",
      chooseVideo: "选择视频",
      dbLibrary: "点播库",
      fileMaxTen: "最多支持10个点播文件",
      // channelrotate 转推
      pushToThird: "转推至第三方平台",
      liveCode: "直播码",
      broadcastLive: "发布直播",
      stopLive: "停止直播",
      zdyPlatform: "自定义平台",
      platformName: "平台名称",
      platformNameNotNull: "平台名称不能为空",
      pushAdsMustRtmp: "推流地址必须为rtmp格式",
      ptNmAndTladsNotNull: "平台名称和推流地址不能为空",
      zbmAndTladsNotNull: "直播码和推流地址不能为空",
      pushAddressNotNull: "推流地址不能为空",
      notl_noFb: "该通道未推流，无法发布直播",
      pushLiveSc: "发布直播成功",
      stopLiveSc: "停止直播成功",
      delSc: "删除成功",
      isDelPt: "你确认要删除该平台吗",
      // ChannelMonitor 监控
      pushWatch: "推流监控",
      pushData: "推流数据",
      liveData: "直播记录",
      pushPullData: "推拉流数据",
      pushPullList: "推断流记录",
      tuiduanliu: "推断流",
      createTime1: "发生时间",
      duanliu: "断流",
      // LiveRecord 直播记录
      today: "今天",
      yesterday: "昨天",
      beforeYesterday: "前天",
      begin_endTime: "开始时间~结束时间",
      searchTimes: "可查询最近60天，查询时间段小于30天的数据",
      pushTimes: "推流时长",
      pushIp: "推流客户端IP",
      pushFbl: "推流分辨率",
      stopReason: "停止推流原因",
      maxTyDay: "查询时间段不能超过30天",
      // StreamData 推流数据
      searchSixDay: "可查询最近6天，查询时间段小于6小时",
      maxSixHour: "查询时间段不能超过6小时",
      //ChartPart 视频帧率 视频码率 音频帧率 音频码率
      VideoFps: "视频帧率",
      VideoRate: "视频码率",
      AudioFps: "音频帧率",
      AudioRate: "音频码率",
      nowNotPush: "此时间段未推流",
      Company: "单位",
    },
    // recordtasklist 录制任务
    recordtask:{
      recordtasklist: "录制任务",
      keyword: "关键字",
      lzrwTip: "请在直播完成后48小时内新建录制任务；单次录制任务不能超过6个小时；录制完成的视频7天后自动删除，请及时移到点播库",
      newRecordtask: "新建录制任务",
      taskName: "任务名称",
      recordTime: "录制时间",
      createTime: "创建时间",
      status: "状态",
      recordChannel: "录制通道",
      autoDel: "自动删除",
      operation: "操作",
      finish: "完成",
      notBegin: "未开始",
      recording: "录制中",
      replayable: "可回放",
      inSynthesis: "合成中",
      recordFail: "录制失败",
      expiredDel: "过期已删除",
      dbkDel: "点播库已删除",
      enterSck: "已进入素材库",
      edit: "编辑",
      synthesis: "立即合成",
      replay: "回放",
      downLoad: "下载",
      moveToSck: "移到素材库",
      del: "删除",
      notLoad: "无法加载",
      noRecordList: "暂无录制任务，快去新建吧～",
      browserNotUse: "您的浏览器不支持。",
      new: "新建",
      Fail: "失败",
      liveNoPush: "直播活动未推流",
      noOpenRecord: "未开启通道全程录制",
      day: "天",
      hour: "小时",
      sysYc: "系统异常",
      delRecordListSc: "删除录制任务成功",
      recordingNotDel: "录制中的不能删除",
      delSure: "删除确认",
      isSureDelRecordList: "你确认要删除录制任务吗",
      tuskSubmit: "任务已提交",
      moveToSckSc: "成功移至素材库",
      tbFbSc: "同步到非编成功",
      noRecordFile: "录制文件不存在",
      // addRecordTaskModal  新建/修改通道
      // playbackModal 回放
      replayAds: "回放地址",
      copy: "复制",
      lzwcEdit: "请在录制任务完成后及时点击“移到素材库”，否则回放地址7天后失效",
      noReplayAds: "未生成回放地址",
      copyOk: "复制成功",
      browserNotCopy: "该浏览器不支持自动复制",
    },
    // watermarklist 直播水印
    watermark:{
      keyword: "关键字",
      addLogo: "添加水印",
      notLoad: "无法加载",
      logoCode: "水印编号",
      axis: "轴",
      edit: "编辑",
      setDefaultLogo: "设置为默认水印",
      cancelLogo: "取消默认水印",
      noLogo: "直播水印为空，快去添加吧～",
      delLogoSc: "删除水印模板成功",
      sysYc: "系统异常",
      delSure: "删除确认",
      isSureDelLogo: "你确认要删除水印模板吗",
      operationSc: "操作成功",
      // addWatermarkModal 新建/编辑水印模板
      // materialListModal2 选择图片
    },
    //connectionList 直播连线
    connection:{
      lineDataList: "连线数据",
      dsfll: "第三方拉流",
      channelHas: "通道已存在",
      issureDelchn: "您确定删除该通道吗",
      empRoom: "该房间处于空闲状态，无法开启开关",
      nowtlTime: "最近推流时间",
      rtmpAdd:"请输入拉流地址，仅支持rtmp格式",
      addTooLang: "拉流地址太长",
      ordinaryRoom: "普通房间",
      majorRoom: "专业房间",
      newRoom: "新建房间",
      roomName: "房间名称",
      type: "模式",
      createTime: "创建时间",
      nowOnline: "当前连线人数",
      roomStatus: "房间状态",
      horizontal: "横屏",
      vertical: "竖屏",
      occupy: "占用",
      free: "空闲",
      invitation: "邀请",
      enterRoom: "进入房间",
      monitor: "监控",
      lineData: "连线记录",
      notCreateZbj: "还没有创建直播间哦～",
      functionNotOpen: "功能未开通，请联系管理员",
      delRoomSc: "删除房间成功",
      isSureDelRoom: "你确认要删除该房间吗",
      serviceExceptions: "服务异常",
      jieruLiveStream:'接入直播流',
      // builtRoomModal 新建房间
      rule1: "请输入1到10位中文、字母、数字、空格或下划线",
      rule2: "中文、字母、数字、空格或下划线",
      alias: "您的别名",
      joinControl: "加入控制端",
      yes: "是",
      no: "否",
      createRoomJkyc: "创建房间接口异常",
      sbRoomJkyc: "上报房间接口异常",
      // enterRoomModal 进入房间
      scyqmErr: "生成邀请码错误",
      aliasRepeat: "别名重复",
      roomLiving: "房间直播中，设置加入控制端失败",
      // recordListModal 连线记录
      timeData: "时长记录",
      totalTime: "累计时长",
      maxOnline: "最高同时连线人数",
      cyData: "成员记录",
      cyName: "成员名称",
      recording: "录制",
      searchErr: "查询错误",
      tjRecordListSc: "提交录制任务成功",
      // inviteConfigModal 邀请设置
      invitationSetting: "邀请设置",
      webInvitation: "WEB邀请",
      copyInfo: "复制信息",
      lineRoomName: "连线房间名称",
      roomCode: "房间号码",
      inviteCode: "房间验证码",
      clickAddLine: "点击链接加入连线",
      appInvitation: "App邀请",
      copyOpenApp: "复制本段话后打开APP",
      reCreateYqm: "重新生成邀请码",
      appEwm: "APP二维码",
      reSetTip: "重新生成邀请会导致现有的邀请失效",
      videoLine: "视频连线",
      welcome: "欢迎进入",
      saveImg: "保存图片到相册",
      openAndJoin: "打开大观直播APP即加入",
      useDaguan: "使用大观APP扫码",
      useWcAdd: "使用微信扫码加入",
      clickJoin: "点击连线加入",
      getRoomErr: "获取房间信息错误",
      // connectionMonitor 监控
      roomMonitor: "房间监控",
      senderUid: "发送方",
      recieverUid: "接收方",
      date: "日期",
      begin_endTime: "开始时间 ~ 结束时间",
      search: "查询",
      wldbl: "网络丢包率",
      wlyc: "网络延迟",
      yspml: "音视频码率",
      videoZl: "视频帧率",
      nodata: "无数据",
      sendDwl: "发送端网络(丢包率)",
      sendDdb: "发送端丢包",
      jsdwl: "接收端网络(丢包率)",
      jsddb: "接收端丢包",
      sendRTT: "发送端RTT",
      jsdRTT: "接收端RTT",
      sendDml: "发送端码率",
      totalSendMl: "总发送码率",
      AudioRate: "音频码率",
      jsdml: "接收端码率",
      totalJsml: "总接收码率",
      sendDzl: "发送端帧率",
      videoClZl: "视频采集帧率",
      videoSjZl: "视频实际帧率",
      jsdZl: "接收端帧率",
      export:'导出',

      yqLine: "赶快邀请好友加入连线吧",
      dklj: "断开连线",
      zmShare: "桌面分享",
      isSureLeaveRoom: "你确认要离开房间吗?",
      lineDk: "连接已断开，无法收到新消息，请检查下你的网络是否正常",
      joinPhone: "加入了通话",
      canotShare: "您的浏览器不支持当前分享类型",
      dbVideo: "点播视频",
      noColseOpt: "请勿直接关闭浏览器，若要停止连线请点击关闭房间按钮",
      closeRoom: "关闭房间",
      shexiangtou: "摄像头",
      stopShare: "停止分享",
      cancelShare: "取消分享",
      nowShare: "立即分享",
      yaoqingLine: "邀请连线",
      videoSet: "音视频设置",
      inputClose: "音视频输入已关闭",
      noJbShare: "没有嘉宾分享",
      sharePm: "您正在分享屏幕",
      closeRooming: "正在关闭房间，请稍等...",
      gGhz: "1080P高画质",
      gTjhz: "1080P推荐画质",
      mgGhz: "720P高画质",
      mgTjhz: "720P推荐画质",
      msGhz: "540P高画质",
      msTjhz: "540P推荐画质",
      sGhz: "360P高画质",
      sTjhz: "360P推荐画质",
      sbsmFail: "上报上麦状态失败",
      noKnowLine: "未知连接状态",
      loginSc: "webim登录成功",
      jsSendFail: "解散消息发送失败",
      mkf: "麦克风",
      cyMng: "成员管理",
      lining: "连线中",
      closeLine: "断开连接",
      yaoqingPhone: "邀请通话",
      removeRoom: "移除房间",
      waitJs: "等待接受",
      waitHj: "等待呼叫",
      exitRoom: "退出房间",
      lineRoomPlsing: "等待连线邀请中...",
      yqphoneLine: "邀请您进行视频连线",
      jujue: "拒绝",
      jieshou: "接受",
      beibojian: "备播间",
      livingRoom: "直播间",
      hmKzing: "画面被控制中",
      sqsmFail: "申请上麦失败",
      zbCloseRoom: "主播关闭了房间",
      exitIMFail: "退出IM群组失败",
      shangbaoFail: "上报失败",
      roomHao: "房间号",
      roomUserName: "房内昵称,中文、字母或数字",
      noLineRoom: "非连线房间",
      inRoom: "已经在房间中，稍后再试",
      enterRoomFail: "进入房间失败",
      nameRe: "名称重复",
      caijiVideoFail: "采集视频流失败，请切换视频设备",
      fblNoZc: "当前分辨率不支持，已为您设置最佳分辨率！最高支持",
      pmShareIng: "正在分享屏幕",
      dbShareIng: "正在分享点播视频",
      vodJz: "声音被禁止",
      createIMFail: "创建IM群组失败",
      enterQunFail: "进群失败",
      enterQunSc: "进群成功",
      beginSharePm: "开始屏幕分享",
      beginShareDb: "开始点播分享",
      endShare: "结束分享",
      shareIng: "正在分享中",
      shareSc: "屏幕分享成功",
      zxjqsq: "执行 加群申请 回调",
      sqjq: "申请加群",
      sqJoinQun: "申请加入你的群",
      sqjqSc: "执行 申请加群被同意 回调",
      sqjqErr: "执行 申请加群被拒绝 回调",
      sqjqBJJ: "申请加群被拒绝",
      jjJoin: "拒绝了你的加群申请，附言",
      jsQun:"执行 解散群 回调",
      IMQunJS: "IM群解散",
      llqbzcDbShare: "当前浏览器不支持点播分享",
      vdoTypeErr: "视频格式错误",
      vdoShareSc: "视频分享成功",
      sharePming: "正在屏幕分享",
      roomNc: "房内昵称",
      reEnter: "重复进入房间",
      roomIdErr: "房间号或验证码错误",
      plsIptRoom: "请输入房间号",
      plsIptRoomNc: "请输入房内昵称",
      zczhYc: "注册账号异常",
      iptTip: "请输入1到30位中文、字母、数字、空格或下划线",
      waitYq: "等待连线邀请中",
      closeLlqBtn: "请勿直接关闭浏览器，若要停止连线请点击关闭/退出房间按钮",
      clsRoom: "正在关闭房间，请稍等",
      youRemoveRoom: "您已被管理员移出房间",
      youDuankaiLine: "您已被管理员断开连接",
      noneMic:'未检测到麦克风',

      zcr: "主持人",
      online: "人正在连线中",
      jingyin: "静音",
      openSxt: "开摄像头",
      shareSreen: "屏幕共享",
    },
    srt:{
      SRTchannelManage: "SRT通道管理",
      SrtChannel: "SRT通道",
      baimingdan: "白名单",
      liuID: "流ID",
      daoqiTime: "到期时间",
      editChannel: "编辑通道",
      anquanModel: "安全模式",
      noJianquan: "无鉴权",
      tokenJianquan: "Token鉴权",
      ipBmd: "IP白名单",
      tip1: "说明：Token鉴权模式下，发送与接收设备需要登录账号",
      tip2: "每行一个IP，如需配置网段可用*号替代",
      cnNamenotNull: "通道名称不能为空",
      editBmd: "编辑白名单",
      oneIp: "每行一个IP;",
      channelList: "通道记录",
      sbSys: "设备系统",
      ipAddress: "P地址",
      netType: "网络类型",
      sbStatus: "设备状态",
      sbType: "设备类型",
      noLive: "无直播",
      srtLl: "SRT拉流",
      searchTime: "可查询最近6天，查询时间段小于3小时。",
      searchTime2: "查询时间段不能超过3小时",
      malv: "码率",
      sendNum: "发送包个数",
      jieshouNum: "接收包个数",
      diubaoNum: "丢包个数",
      resendNum: "重传个数",
      thisTimeNoLl: "此时间段未拉流",
      thisTimeNoTl: "此时间段未推流",
      haomiao: "毫秒",
      ge: "个",
      Company: "单位",
    },
    srtLl:{
      srtLlManage: "SRT拉流管理",
      fwqIp: "服务器IP",
      llIp: "拉流IP",
      llStatus: "拉流状态",
      nopull: "未拉流",
      pullTime: "拉流时间",
      lldIp: "拉流端IP",
      area: "区域",
      noList: "暂无记录～",
    },
    // flowmonitorList  直播流监控
    flowmonitor:{
      liveMatches: "赛事直播",
      liveMonitor: "信号监控",
      newMonitor: "新建监控",
      bigScreenName: "大屏名称",
      bigScreen: "大屏",
      screenLayout: "屏幕布局",
      createTime: "创建时间",
      noLiveMonitor: "还没有创建信号监控哦～",
      isSureDelMonitor: "你确认要删除该监控吗",
      // flowmonitorEdit 直播流监控修改
      layout: "布局",
      bigScreenTopShow: "大屏顶栏显示",
      batchAdd: "批量添加",
      openBigScreen: "打开大屏",
      goOut: "退出",
      noLive: "暂无直播流",
      noCut: "暂无截图",
      newCutTime: "最近截图时间",
      notOpenSsjt: "未开启实时截图",
      addLive: "添加直播流",
      znjb: "智能鉴别",
      notOpen: "未开启",
      violation: "违规",
      suspected: "疑似",
      normal: "正常",
      nameNotNull: "名称不能为空",
      // identifyRecordModal 鉴别记录
      setUp: "设置",
      tipBef: "如有需要，请您将图片下载至本地浏览或留存，系统将在",
      tipAft: "小时后自动删除",
      download: "下载",
      noKown: "未知",
      yellow: "涉黄",
      terrorism: "涉恐",
      politics: "涉政",
      // setMonitorModal 添加通道监控
      channelName: "通道名称",
      status: "状态",
      monitorMode: "监看模式",
      nowStream: "实时流",
      ssjt: "实时截图",
      minOneChannel: "至少选择一个通道",
      addSc: "添加成功",
      autoPage: "自动翻页",
      jkChannelName: "监控通道名称",
      genghuang: "更换",
      addChannel: "添加通道",
      beginAdd: "开始添加",
      dianji: "点击",
      bcyxz: "本次已选择",
      max100ge: "最多选择100个",
      // bigScreen 大屏
      shlJk: "流数据监控",
      llData: "拉流数据",
      malv: "码率",
      zhenlv: "帧率",
      zhen: "帧",
      liuliang: "流量",
      bingfs: "并发数",
      ci: "次",
      tianjia: "添加",
      delJkjl: "存在被删除通道，已自动清除监控记录"
    },
    signal:{
      stopFf: "停止分发",
      xhy: "信号源",
      chooseXh: "选择信号",
      showCzhm: "显示抽帧画面",
      moreInfo: "详情",
      choosePt: "选择平台",
      lddjz: "流调度矩阵",
      sureStopFf: "停止分发确认",
      issureStopAll: "是否停止当前所有分发",
      changeSure: "切换确认",
      isSureChange: "当前平台已有信号源，是否切换",
      isSureDel: "当前直播流正在转推中，删除该通道将会影响转推画面，是否继续操作",
      chooseFfPt: "选择分发平台",
      plsChoosePt: "请选择平台",
      xhyxq: "信号源详情",
      beginTlTime: "开始推流时间",
      dataMolitor: "监控数据",
      xhyPx: "信号源排序",
      ffptPx: "分发平台排序",
    }
  },
  channel:{
    chooseChannel: "选择通道",
    ptChannel: "普通通道",
    liveStatus: "直播状态",
    sszbtd: "赛事直播通道",
    quanbu: "全部",
    zhunbeiing: "准备中",
    canCt: "可拆条",
    plsChooseTd: "请选择通道",
  },
  // vod 云点播
  vod:{
    videoUpload: "视频上传",
    videoManage: "视频管理",
    commentManage: "合辑管理",
    plManage: "评论管理",
    rideoMng: "音频管理",
    // uploadList 视频上传
    uploadList:{
      uploadTo1: "上传至",
      uploadTip: "文件正在上传中，请勿刷新或关闭此页面",
      enable: "启用",
      deactivate: "停用",
      zm_sy: "转码/水印",
      beginUpload: "开始上传",
      addMoreVd: "添加更多视频",
      fileName: "文件名",
      size: "大小",
      status: "状态",
      type: "分类",
      chooseVideoUpld: "选择视频文件上传",
      tzdckUpload: "或直接将文件拖拽至此窗口",
      maxFt: "最多40个字符",
      waitUpload: "等待上传",
      uploading: "上传中",
      uploaded: "上传完成",
      chooseTemp: "选择模板",
      chooseLogo: "选择水印",
      tsUpload: "同时上传",
      geFile: "个文件",
      videoTypeErr: "视频格式不正确",
      videoNameMaxFt: "视频名称不能超过40个字符",
      file: "文件",
      uploadSc: "上传成功",
      videoNameNotNull: "视频名称不能为空",
      plsCsVideo: "请选择视频",
      // transcodeWatermarkModal 转码/水印
      zmTemp: "转码模板",
      logoTemp: "水印模板",
      chsSyOrZmTemp: "请选择水印模板或转码模板",
      chooseWjj: "选择文件夹",
    },
    // videoManageList 视频管理
    videoManageList:{
      begin_endTIme: "开始时间  ~  结束时间",
      byName: "按名称",
      byLabel: "按标签",
      bycharacter: "按人物",
      plsPointKeyword: "请输入关键字搜索",
      enable: "启用",
      deactivate: "停用",
      join: "加入",
      classify: "分类",
      collection: "合辑",
      zm: "转码",
      qrcs: "嵌入参数",
      cut: "剪辑",
      info: "基本信息",
      status: "状态",
      uploadTime: "上传时间",
      enableStatus: "启用状态",
      shStatus: "审核状态",
      size: "大小",
      time: "时长",
      processing_zm: "处理中（原画转码成功）",
      processing: "处理中",
      zmSc: "转码成功",
      zmFail: "转码失败",
      thirdPass: "三审通过",
      secondPass: "二审通过",
      firstPass: "一审通过",
      notApproved: "未审核",
      thirdNotPass: "三审不通过",
      secondNotPass: "二审不通过",
      firstNotPass: "一审不通过",
      address: "地址",
      yuny: "运营",
      share: "分享",
      douyin: "抖音",
      toutiao: "头条",
      sourceChange: "换源",
      embed: "嵌入",
      noVideoFIle: "还没有视频文件哦～",
      allVideo: "全部视频",
      uploadVideo: "上传视频",
      recordVideo: "录制视频",
      cloudCut: "云剪辑",
      shortVideo: "短视频",
      thirdParty: "第三方",
      operationSc: "操作成功",
      delVideoSc: "删除视频成功",
      isSureDelVideo: "你确认要删除视频吗",
      plsChooseVideo: "请选择视频",
      setSc: "设置成功",
      radioFile: "音频文件",
      notZm: "不能进行转码",
      plzmtjSc: "批量转码任务提交成功",
      videoXz: "选择的视频时长或文件大小超出规则，请参考视频分享规范",
      ckxq: "查看详情",
      noCutGn: "未开通剪辑功能",
      hasZmfailVideo: "含有转码不成功的视频",
      // transcodeWatermarkModal 转码/水印
      // playUrlModal 播放地址modal
      // previewModal 视频预览
      playAddress: "播放地址",
      browserNotUse: "您的浏览器不支持。",
      yh: "原画",
      // changeSourceModal 换源modal
      chooseBdFile: "选择本地文件",
      uploadProgress: "上传进度",
      logo: "水印",
      chooseLogo: "选择水印",
      logeTip: "历史水印已删除，请指定新的水印",
      beginUpload: "开始上传",
      pauseUpload: "暂停上传",
      cancelSure: "取消确认",
      isSureCancel: "你确认要取消上传吗",
      uploadSc: "上传成功",
      // toClassifyModal 加入到分类modal
      addToTYpe: "加入到分类",
      typeName: "分类名称",
      chsSyOrZmTemp: "请选择水印模板或转码模板",
      // toCompilationModal 加入到合辑modal
      addToCollection: "加入到合辑",
      addClctSc: "添加到合集成功",
      chooseClct: "请选择合辑",
      // vodEditModal 点播编辑modal
      name: "名称",
      plspointName: "请输入名称",
      cover: "封面",
      uploadImg: "上传图片",
      jianjie: "简介",
      plsPointJj: "请输入简介",
      videoNameNotNull: "视频名称不能为空",
      oneToFt: "1到40个字符",
      uploadImgSc: "上传图片成功",
      uploadImgFail: "上传图片失败",
      imgTypeErr: "上传图片格式有误，请重新上传",
      modifiedSc: "修改成功",
      // implantModal 单个嵌入设置modal
      bfqSize: "播放器大小",
      autoPlay: "自动播放",
      width: "宽",
      height: "高",
      showAuto: "如其中一项为0，则表明该项为自适应",
      copyCode: "复制代码",
      videoYsSize: "视频原始大小",
      selfSet: "自定义",
      // implantAllModal all嵌入设置modal
      zcyhPlay: "支持原画播放",
      // sharedNormsModal 抖音视频分享规范
      dyspfxgf: "抖音视频分享规范",
      ttspfxgf: "头条视频分享规范",
      dyfxTip1: "视频文件大小不超过300M，时长在1分钟以内。",
      dyfxTip2: "带品牌logo或品牌水印的视频，会命中抖音的审核逻辑，有比较大的概率导致分享视频推荐降权处理/分享视频下架处理/分享账号被封禁处理。强烈建议第三方应用自行处理好分享内容中的不合规水印。",
      dyfxTip3: "视频分享至抖音后，抖音会进行审核，视频审核逻辑与端上一致。",
      ttfxTip2: "带品牌logo或品牌水印的视频，会命中头条的审核逻辑，有比较大的概率导致分享视频推荐降权处理/分享视频下架处理/分享账号被封禁处理。强烈建议第三方应用自行处理好分享内容中的不合规水印。",
      ttfxTip3: "视频分享至头条后，头条会进行审核，视频审核逻辑与端上一致。",
      IKonw: "我知道了",
      // douyinShareModal 抖音分享
      doeyinShare: "抖音分享",
      shareTo: "分享至",
      shareData: "分享记录",
      zhgq: "账号过期",
      videoMs: "视频描述",
      addZhL: "添加账号",
      shareTime: "分享时间",
      zhName: "账号名称",
      shareStatus: "分享状态",
      close: "关闭",
      success: "成功",
      shareing: "分享中",
      fail: "失败",
      chooseZh: "请选择账号",
      subSc: "提交成功",
      // toutiaoShareModal 头条分享
      toutiaoShare: "头条分享",
      // vodInterception2 智能识别截取
      yl_jq: "预览/截取",
      jqTime: "时间截取",
      noHcpd: "无合成片段",
      noEditQy: "不可操作区域",
      znLabel: "智能标签",
      yysb: "语音识别",
      faceSb: "人脸识别",
      videoCut: "视频截图",
      downloadSRT: "下载SRT",
      reSb: "重新识别",
      noyysbCont: "暂无语音识别内容",
      noFaceSbCont: "暂无人脸识别内容",
      timeNotNull: "时间不能为空",
      timeTypeErr: "时间格式不正确",
      timeNotYy: "时间不在有效范围内",
      begin: "开始",
      end: "结束",
      endTimeLgBeginTime: "结束时间应该大于开始时间",
      cutSc: "剪切成功",
      fqsbSc: "发起识别成功",
      notSb: "未识别",
      sbing: "识别中",
      sbFail: "识别失败",
      inSynthesis: "合成中",
      hechengFail: "合成失败",
      finished: "已完成",
      // videoManageOperation  运营
      hdSet: "互动设置",
      pageSet: "页面设置",
      msgInteraction: "留言互动",
      kaiqi: "开启",
      lysh: "留言审核",
      xshf: "先审后发",
      xfhs: "先发后审",
      viewSet: "授权观看设置",
      noXz: "无限制",
      yzmView: "验证码观看",
      userCanViewPd: "用户可自由观看此频道",
      textTip: "提示文字",
      plsIptTextTip: "请输入提示文字",
      zdyYzm: "自定义验证码",
      plsIptYzm: "请输入验证码",
      plsTxYzm: "请填写验证码",
      wxgzhQr: "微信公众号嵌入",
      addAddressToWx: "将以下地址添加至您的微信公众号自定义菜单内，观众可通过点击公众号菜单快捷访问您的直播页",
      qrwxgzhAds: "嵌入微信公众号的地址",
      zdyPlay: "自定义播放页",
      gzyd: "关注引导",
      ggl: "广告栏",
      dbList: "点播列表",
      viewPsNum: "观众人数",
      openClose: "开关",
      ewm: "二维码",
      dbText: "底部文字",
      gzhName: "公众号名称",
      xgslt: "效果示例图",
      plsUploadImg: "请先上传图片",
      dbTextNotNull: "底部文字不能为空",
      gzhNameNotNull: "公众号名称不能为空",
      uploadImgSize: "建议上传尺寸为1080*135像素的图片",
      text: "文字",
      image: "图片",
      plsIptText: "请输入文字",
      ddggtz: "点击广告跳转至",
      plsIptTzlj: "请输入跳转链接",
      newGg: "新建广告",
      isSureDel: "确认要删除吗",
      editGg: "编辑广告",
      ggTextNotNull: "广告文字不能为空",
      ggImgNotNull: "广告图片不能为空",
      modeName: "模块名称",
      chooseHj: "选择合辑",
      modeNameNotNull: "模块名称不能为空",
      hjNotNull: "合辑不能为空",
      showType: "展示形式",
      totalNum: "累计人数",
      videoplayNum: "视频播放量",
      addType: "增加形式",
      mrjcNum: "默认基础人数",
      people: "人",
      sjNum: "实际人数",
      times: "倍",
      notes: "注",
      jsfs: "显示观众人数 = 默认基础人数 + 实际人数 × 倍数",
      addTip: "该数据只为前端用户展现，后台数据以真实数据统计",
      plEdit: "批量操作",
      newFloal: "新建文件夹",
      returnLast: "返回上一级",
      allFile: "全部文件",
      resetName: "重命名",
      fileboxNotNull: "文件夹名称不能为空",
      moveTo: "移动到",
      uploadTo: "上传到",
      filebox: "文件夹",
      movetoThis: "移动到此处",
      uploadtoThis: "上传到此处",
      nowNoVideo: "暂无视频",
    },
    // 音频管理
    rideoManage:{
      uploadIng: "文件正在上传中，请勿刷新或离开此页面",
      ypName: "音频名称",
      ypType: "音频类型",
      uploadYp: "上传音频",
      loadToUp: "等待上传",
      uploadTo: "上传至",
      uploadFail: "上传失败",
      uploadEnd: "上传完成",
      noYpfile: "还没有音频文件哦",
      bdUpload: "本地上传",
      zbLz: "直播录制",
      isSureDelFile: "你确认要删除该音频文件吗",
      typeFail: "音频格式不正确",
      filenameTooLong: "音频名称不能超过50个字符",
      ypLogo: "音频封面",
      mp3Address: "mp3地址",
      m4aAddress: "m4a地址",
      play: "播放",
      noUseBq: "您的浏览器不支持 audio 标签。",
    }
  },
  // production 云制作
  production:{
    guideMng: "导播管理",
    cgMng: "CG管理",
    materialMng: "素材管理",
    pictureSplicing: "画面拼接",
    // directorList 导播管理
    directorList: {
      useNewChromeTip: "为了确保导播台正常运行，建议使用最新版本Chrome浏览器",
      newguide: "新建导播",
      guideId: "导播台ID",
      guideName: "导播台名称",
      guideStatus: "导播台状态",
      guideSyTime: '导播剩余时长',
      open_close: "启用/停用",
      zeng: "赠",
      enterGuide: "进入导播台",
      xiugai: "修改",
      noGuideToBuide: "暂未创建导播台，快去新建哟～",
      welcomeUseGuide: "欢迎使用融云导播台",
      chooseGuideTime: "选择导播时长",
      chooseGuideType: "选择导播模式",
      normalMode: "普通模式",
      active_standby: "主备模式",
      ljxhjr: "连线信号接入",
      guideTip1: "云导播可接入连线信号，通过低延迟信号回传，",
      guideTip2: "实现记者与主持人对话、嘉宾采访等节目制作效果",
      PGMhmfs: "PGM画面返送",
      gudieTip3: "云导播的PGM画面将返送至连线房间内，",
      guideTip4: "前方记者可实时查看当前的节目播出情况",
      billingType: "计费方式",
      oneUseOne: "1分钟导播消耗1G直播流量",
      plsTime: "请保证导播时长充足",
      payAttenTion: "注意事项",
      attion1: "导播台采取先使用后付费的形式，若导播提前结束，则只按照使用的时长扣费，",
      attion2: "当余额不足时，导播间会赠送您15分钟，过时会自动关闭，请务必保证导播时长余量充足；创建后开始计费。",
      chooseLineRoom: "选择连线房间",
      cloudProduct: "云制作主页",
      oneHour: "一小时",
      twoHour: "二小时",
      threeHour: "三小时",
      fourHour: "四小时",
      fiveHour: "五小时",
      sixHour: "六小时",
      sevenHour: "七小时",
      resourceDoing: "资源准备中",
      guideing: "导播中",
      resourceReturn: "资源归还中",
      guideStop: "导播停止",
      noKown: "未知",
      roomUseing: "该导播间正在使用，请稍后再试",
      serviceExceptions: "服务异常",
      guideDis: "导播台已停用",
      isSureDisGuide: "确认停用该导播台吗",
      opSure: "操作确认",
      noRoomPlsChs: "连线房间已不存在,请重新选择",
      guideNameNotNull: "导播台名称不能为空",
      roomMust: "必须选择连线信号房间",
      plsChooseLineRoom: "请选择连线房间",
      delGuideSc: "删除导播间成功",
      isSureDisRoom: "你确认要删除该导播间吗",
      // directorManagementActive 导播控制页面
      guide: "导播台",
      canuseTime: "可用时长",
      addTime: "添加时长",
      goOut: "退出",
      noLive: "无直播流",
      mode: "模板",
      compositePicture: "合成画面",
      change: "切换",
      outPlay: "输出设置",
      delayPic: "延时画面",
      soundMonitor: "声音监听",
      volume: "音量",
      mediaSource: "媒体源",
      taibiao: "台标",
      img: "图片",
      caption: "字幕",
      keyboard: "快捷键",
      keyboardSign: "键盘快捷键说明",
      sign1: "Ctrl+数字键：输出到PVW",
      sign2: "数字键：输出到PGM",
      sign3: "Enter键：PVW/PGM切换",
      pointSet: "输入设置",
      voliceWatch: "声音监听",
      voliceOutput: "声音直接输出",
      setPosition: "调整位置",
      toping: "置顶",
      setUp: "设置",
      detPic: "默认图片",
      picFollow: "跟随画面",
      addCap: "添加字幕",
      horseLamp: "跑马灯",
      chooseStateLogo: "选择台标",
      chooseImg: "选择图片",
      position: "位置",
      leftTop: "左上",
      rightTop: "右上",
      leftBottom: "左下",
      rightBottom: "右下",
      chooseSry: "选择输入源",
      liveChannel: "直播通道",
      dbsc: "点播素材",
      chooseSrtd: "选择输入通道",
      pushAddress: "推流地址",
      allVideo: "全部视频",
      uploadVideo: "上传视频",
      lzVideo: "录制视频",
      cloudCutVideo: "云剪辑视频",
      editZm: "编辑字幕",
      fontFamily: "字体",
      fontSize: "字体大小",
      fontColor: "字体颜色",
      bgColor: "背景颜色",
      qiehuan: "切换",
      followHm: "跟随画面",
      yes: "是",
      captionSpeed: "文字速度",
      fast: "快",
      nomal: "中",
      man: "慢",
      bgBtmd: "背景色不透明度",
      captionContent: "文字内容",
      chooseChannel: "选择通道",
      definitionSet: "清晰度设置",
      scml: "输出码率",
      resolePower: "分辨率",
      playPt: "播出平台设置",
      delayTl: "延时推流",
      chooseSctd: "选择输出通道",
      dbtxf: "导播台续费",
      chooseDbTime: "选择导播时长",
      jffsSm: "1分钟导播消耗1G直播流量（或50分钟观看时长）",
      jffsTs: "请保证导播时长充足或直播时长至少大于导播时长",
      jffsTip1: "融云导播台采取先使用后付费的形式，若导播提前结束，则只按照使用的时长扣费，",
      jffsTip2: "当余额不足时，导播间会赠送您15分钟，过时会自动关闭，请务必保证直播时长余量充足；创建后开始计费。",
      toolTip: "提示",
      tipContent: "关闭后导播台将停止输出，剩余的导播时长不会产生计费，再次使用需要重新开启。",
      wryh: "微软雅黑",
      songti: "宋体",
      heiti: "黑体",
      kaiti: "楷体",
      closeSure: "关闭确认",
      plsClickToClose: "该导播台已停用，请点击确认关闭导播",
      cannotEditUsing: "无法修改使用中的机位",
      plsChooseChannel: "请选择一个输入通道",
      plsChooseFile: "请选择一个点播文件",
      notDelUse: "无法删除使用中的机位",
      notDelRadioJw: "无法删除声音正在输出的机位",
      isSureDelJw: "你确认要删除该机位吗",
      videoJy: "视频暂停状态下，无法输出声音",
      hcSc: "合成成功",
      qiehuanSc: "切换成功",
      hcJwNull: "合成机位不存在或无直播流",
      cfjw: "存在重复机位，无法进行合成",
      plsChooseTemp: "请选择合成模板",
      canUseTimeTt: "可用时长不足30分钟，请及时新增导播时长",
      canUseTimeTen: "可用时长不足10分钟，请及时新增导播时长",
      balance: "您的余额已不足，导播台免费赠送您15分钟，请及时充值",
      xfSc: "续费成功",
      dbtStop: "导播已停止，无法正常充值",
      balanceAndRecharge: "余额不足，请充值后续费",
      plsStopToPzxx: "请先停止直播，才能设置配置信息",
      plsChooseOneChannel: "请选择一个输出通道",
      setSc: "设置成功",
      stopOutput: "停止输出",
      beginOutput: "开始输出",
      isSureDelTaibiao: "你确认要删除该台标吗",
      addSc: "添加成功",
      isSureDelPic: "你确认要删除该图片吗",
      setTopSc: "置顶成功",
      contentNotNull: "文字内容不能为空",
      isSureDelZimu: "你确认要删除该字幕吗",
      netErr: "网络错误",
      videoDecodingErr: "视频解码错误",
      notPlayVideoType: "不支持播放该视频格式",
      nousePlayerOnFile: "请勿在 file 协议下使用播放器",
      paramaterErr: "使用参数有误",
      pointVideoAddress: "请填写视频播放地址",
      liveEnd: "直播已结束",
      getVideoFail: "获取视频失败",
      kybjj: "跨域访问被拒绝",
      // directorPreview 导播预览页面
      yulanDelay: "预览画面：延时",
      yh: "原画",
      // directorStation 导播台操作
      qpEdit: "F11键：全屏操作",
      fullScreen: "全屏",
      jjqb: "紧急切播",
      hfzb: "恢复直播",
      stopZb: "停止直播",
      beginZb: "开始直播",
      mixer: "调音台",
      yspStemp: "音视频同步",
      beforeImg: "前景图",
      bgImg: "背景图",
      guideSc: "导入素材",
      noImgSc: "暂无图片素材",
      guideZm: "导入字幕",
      box: "盒子",
      text: "文字",
      title: "标题",
      noZmsc: "暂无字幕素材",
      noLineRoom: "暂无连线房间",
      lineRoomJsL: "连线房间已解散",
      cyName: "成员名称",
      seat: "机位",
      invitation: "邀请",
      remove: "移除",
      joinCall: "加入通话",
      endCall: "结束通话",
      voice: "声音",
      video: "视频",
      noDDRsc: "暂无DDR素材",
      waitDownload: "下载未开始",
      downloading: "下载中",
      downloaded: "下载完成",
      downloadFail: "下载失败",
      entryPoint: "入点",
      outPoint: "出点",
      cycleIndex: "循环次数",
      infinite: "无限",
      startLocation: "启播位置",
      videoEntryPoint: "视频入点",
      followPIP: "跟随PIP画面",
      addDDRsc: "添加DDR素材",
      system: "系统",
      chooseInpSource: "选择输入源",
      pushFlow: "推流",
      pullFlow: "拉流",
      pushType: "推流类型",
      RTMPchannel: "RTMP通道",
      SRTpush: "SRT推流",
      sytlfs: "适用于SRT点对点的推流方式",
      fzzthtl: "将SRT地址复制后，粘贴至推流设备中进行推流",
      UDPPush: "UDP推流",
      syUDPtlfs: "适用于UDP点对点的推流方式",
      UDPfzzttl: "将UDP地址复制后，粘贴至推流设备中进行推流",
      channelAddress: "通道地址",
      srtAddress: "SRT地址",
      udpAddress: "UDP地址",
      pullAddress: "拉流地址",
      xyAddress: "rtmp、srt、http或udp协议地址",
      chooseVideoFile: "选择视频文件",
      editBeforeImg: "编辑前景图",
      name: "名称",
      inputName: "输入名称",
      transparency: "透明度",
      picFollow: "画面跟随",
      editBgImg: "编辑背景图",
      chooseMode: "选择模板",
      editMode: "编辑模板",
      lcdmbk: "另存到模板库",
      front: "前面",
      dehind: "后面",
      add: "添加",
      chooseCaptionBox: "选择字幕盒",
      editName: "修改名称",
      captionBoxName: "字幕盒名称",
      plsInpName: "请输入名称",
      showType: "显示方式",
      showFixed: "固定显示",
      cyclicScroll: "循环滚动",
      textSpeed: "文字速度",
      textFamily: "文字字体",
      textSize: "文字大小",
      textColor: "文字颜色",
      BgTmd: "背景透明度",
      content: "内容",
      setOutput: "设置输出",
      outputTo: "输出到",
      zdyPush: "自定义推流",
      outputChannel: "输出通道",
      rtmpOrsrtXydd: "rtmp或srt协议地址",
      jjbb: "紧急备播",
      openClose: "开启/关闭",
      canOpenJjbp: "设置3秒以上延时可开启紧急备片",
      chooseVideo: "选择视频",
      notStart: "未开始",
      zhz: "转码中",
      zyzbwc: "资源准备完成",
      zyzbFail: "资源准备失败",
      guideRenew: "导播台续费",
      chooseGuideTime: "选择导播时长",
      exitTip: "退出提示",
      hmPreview: "画面预览",
      null: "无",
      guideNoCont: "该机位无内容，无法添加",
      cannotAddmoreJw: "无法添加更多机位",
      bdbNotEditWatch: "备导播不能修改监听",
      plsChooseRtmpChannel: "请选择一个rtmp通道",
      plschooseSrtChannel: "请选择一个srt通道",
      plsChooseUdpChannel: "请选择一个udp通道",
      pullAddressNotNull: "拉流地址不能为空",
      pullAdressType: "拉流地址必须为rtmp、srt、http或udp协议",
      notChangeHm: "无法切换画面",
      qwpfcz: "请勿频繁操作",
      pushAddressNotNull: "推流地址不能为空",
      pushAddressMustType: "推流地址必须为rtmp或srt协议",
      openJjbb: "开启紧急备播，延时推流必须大于3秒",
      addAJjbbVideo: "请添加一个紧急备播视频",
      sourceZbz: "备播资源正在准备中，无法修改码率和分辨率",
      plsSetSccs: "请设置输出参数",
      plsChooseAChannel: "请选择一个输出通道",

      // sxb4director.js
      notDelUseJw: "无法删除使用中的机位",
      notEditUseJw: "无法修改使用中的机位",
      lineRoomNoExistence: "连线房间不存在",
      LoginLineRoomErr: "登录连线房间错误",
      roomJkYc: '上报房间接口异常',
      exitLiveFail: "调用退出直播API间失败",
      // im4director.js
      acceptedInvitation: "接受了邀请",
      refuceJoin: "拒绝加入房间",
      leaveRoom: "离开了房间",
      enterRoom: "进入了房间",
      disconnected: "断开了通话",
      jsIMfail: "解散IM群失败",
      maxEtTh: "最多支持8人通话",
      // imClient4director.js
      loginIMFail: "登录IM失败",
      errCode: "错误码",
      createQzFail: "创建群组失败",
      editQbmFail: "修改群别名失败",
      joinIMQzFail: "加入IM群组失败",
      joinIMFailContent: "加入IM群组失败， 响应状态信息",
      joinQzFail: "加入群组失败",
      exitQzFail: "退出群组失败",
      editTIMFail: "退出TIM失败",
      sendQzFail: "发送群组消息失败",
      sendc2cFail: "发送c2c消息失败",
      joinIMQzSc: "加入IM群组成功",
      c2cIMxx: "c2c未知的IM消息",
      noKownIM: "未知的IM消息",
      sysQinfo: "系统群消息",
      // rtc4director.js
      plsSureWl: "请确保您的网络连接是正常的，您可以先体验一下我们的Demo以确保网络连接是正常的",
      plsSureInfo: "另外，请确保您的账号信息是正确的。",
      plsOpenLink: "请打开链接",
      showMoreInfo: "查询详细错误信息",
      rtcYc: "rtc网络异常，请刷新页面重试",
      shareScreen: "屏幕分享",
      shareDb: "点播分享",
      // ddr4director.js
      chooseVideoAndMinTime: "请选择时长不小于5s的视频",
      cannotDeluse: "无法删除使用中的资源",
      isSureDelSource: "你确认要删除该资源吗",
      sourceDownload: "资源正在下载中，请稍等",
      // emerg4director.js
      beginJjqb: "开始紧急切播",
      stopJjqb: "停止紧急切播",
      // cg4director.js
      chooseAddImg: "请选择需要添加的图片",
      nameNotNull: "名称不能为空",
      picAndZmMaxTy: "图片和字幕的使用个数不能超过20个",
      useSc: "使用成功",
      cancelUse: "取消使用",
      plsChooseAddTemp: "请选择需要添加的模板",
      isSureDelTemp: "你确认要删除该模板吗",
      tempNameNotNull: "模板名称不能为空",
      plsAddMode: "请添加模块",
      editSc: "编辑成功",
      // subtitle4director.js
      zangwen: "藏文",
      mengwen: "蒙文",
      weiwen: "维文",
      chaoxianwen: "朝鲜文",
      plsChooseZmh: "请选择需要添加的字幕盒",
      xiugaiSc: "修改成功",
      isSureDelZmh: "你确认要删除该字幕盒吗",
      isSureDelZmt: "你确认要删除该字幕条吗",
      contentMust: "内容不能为空",
      addParkInTemp: "请在模板中添加机位",
      noContentInTemp: "模板中的机位无内容",
      noContentToAdd: "该机位无内容，无法添加",
      recordFile: "录制文件",
      currenttime: "当前时间",
      availabletime: "可用时长",
      follow: "跟随",
      cameraSwitch: "机位切换",
      templateSwitch: "模板切换",
      transitionEffects: "转场特效",
      clicktoselectchannel: "点击选择通道",
      pgmCleanRecording: "PGM Clean录制",
      cleanMsg1: "开启后，对PGM的流画面进行Clean录制",
      cleanMsg2: "录制内容不包括画面上的前景图和字幕",
      cleanMsg3: "如果有背景图，会同画面一起录制下来",
      viewRecordingList: "查看录制列表",
      diskMsg1: "当前电脑磁盘剩余",
      diskMsg2: "当前输出码率为",
      diskMsg3: "预计可录制时长",
      controlMsg1: "拥有控制权",
      controlMsg2: "正在获取控制权",
      controlMsg3: "获取控制权",
      controlMsg4: "导播权限已切换",

      PGMfs: "PGM返送",
      zcfail: "注册失败",
      ydblzwj: "云导播录制文件",
      delAfterSeven: "录制完成的视频7天后自动删除",
      gqTime: "过期时间",
      noLzwj: "暂无录制文件",
      issureDelLzwj: "你确认要删除该录制文件吗",
      welcomeDbt: "欢迎使用导播台",
      chooseDbType: "选择导播类型",
      ydbTip1: "云导播台按照运行分钟数扣费，采取先使用后付费的形式",
      ydbTip2: "若导播提前结束，则只按照使用的时长扣费",
      ydbTip3: "当余额不足时，导播间会赠送您5分钟，过时会自动关闭，请务必保证导播时长余量充足；创建后开始计费",
      nosearchCont: "暂无搜索内容",
      lineLx: "连线",
      bianji: "编辑",
      zwspsc: "暂无视频素材",
      addSpsc: "添加视频素材",
      channel: "通道",
      changeFail: "切换失败",
      yebzzs5: "您的余额已不足，导播台免费赠送您5分钟，请及时充值",
      addPGMtoLive: "请先添加PGM信号后再开始直播",
      pzSc: "配置成功",
      peizhi: "配置",
      pailie: "排列",
      captionBg: "字幕背景",
      miaobian: "描边",
      mbcx: "描边粗细",
      yinying: "阴影",
      spPy: "水平偏移",
      czPy: "垂直偏移",
      mhcd: "模糊程度",
      duiqi: "对齐",
      linehight: "行高",
      zijianju: "字间距",
      noLine: "未连接",

      yinpin: "音频",
      importYp: "导入音频",
      noYpFile: "暂无音频素材",
      outputJw: "输出机位",
      cancelOutput: "取消输出",
      output: "输出",
      ypChoose: "音频选择",
      plsChooseImg: "请选择一张图片",
      noDownload: "音频未下载完成，暂时无法输出",
      noMusic: "没有音频文件，无法输出",
      wbdjw: "未绑定机位，无法输出",
      shuchuSc: "输出成功",
      isDelMusic: "你确认要删除该音频吗",
      musicTime: "音频时长",
      plaseChooseFile: "请选择文件",
      musicPlaySet: "音频播放设置",
      setRudian: "设入点",
      setOut: "设出点",
      rddycd: "入点不能大于出点",
      crdjg: "入出点间隔不能小于5秒",
      cddyrd: "出点必须大于入点",
      jwSet: "机位设置",
      chooseTlchannel: "请选择推流通道",
      ydChoose: "云端选择",
      changeTh: "替换",
      tpjybl: "图片比例建议为",
      searchOnList: "在列表页中搜索",
    },
    // CG管理
    cgManage:{
      beforeImg: "前景图",
      bgImg: "背景图",
      temp: "模板",
      subtitle: "字幕",
      subunit: "组件",
      // foreground 前景图
      cloudImport: "云端素材导入",
      uploadImg: "上传图片",
      noForeground: "暂无前景图片~",
      scImportSc: "素材导入成功",
      uoploadImgSc: "上传图片成功",
      uploadImgFail: "上传文件失败",
      uploadImgTypeErr: "上传图片格式有误，请重新上传",
      uploadImgSize: "上传图片大小不得超过20M",
      imgDeled: "图片已删除",
      isSureDelImg: "您确定删除该图片吗",
      editImg: "编辑图片",
      plsChooseImg: "请选择图片",
      noContent: "暂无内容",
      // background 背景图
      noBackground: "暂无背景图片~",
      // formwork 模板
      addMode: "添加模板",
      noSubtitle: "暂无导播模板~",
      modeDeled: "模板已删除",
      isSureDelMode: "您确定删除该模板吗",
      editMode: "编辑模板",
      newMode: "新建模板",
      modeName: "模板名称",
      // subtitle 字幕
      newSubitleh: "新建字幕盒",
      return: "返回",
      newSubitlet: "新建字幕条",
      subitlehDeled: "字幕盒已删除",
      isSureDelSubitleh: "您确定删除该字幕盒吗",
      subitletDeled: "字幕条已删除",
      isSureDelSubitlet: "您确定删除该字幕条吗",
      editSubitleh: "编辑字幕盒",
      newSubitleh: "新建字幕盒",
      newSubtitle: "新建字幕",
      nottitTemp: "暂无标题模板",
      titleNotNull: "标题名称不能为空",
      creatImging: "正在生成图片，请稍等",
      creatImgFail: "生成图片失败",
      uploadImgFail: "上传图片失败",
      // subunit 组件
      upload: "上传",
      addWindow: "添加窗口",
      imageImport: "图片导入",
      cloud: "云端",
      local: "本地",
      cameraSelect: "机位选择",
      positionNotRequired: "机位非必填，可进入导播台后根据实际使用情况添加",
      donotAddSame: "请勿添加相同机位",
      layer: "图层",
      moreWarning: "*注意：当多于4个窗口时，多个窗口建议不要重叠布局，防止导播过程中出现性能过度消耗",
      noMore8: "窗口最多不能超过8个",

      moreRen: "默认",
      newText: "新建文字",
      gouxuanTip1: "勾选后，首次添加图片会出现在PVW画面中，并且图片会跟随PVW移动",
      nogouxuanTip2: "不勾选，图片会同时出现在PVW和PGM画面中",
      chuangkou: "窗口",
      addHp: "添加横屏",
      addSp: "添加竖屏",
      yunddr: "云端导入",
      bddr: "本地导入",
      chooseImg: "图片选择",
      notChooseMore: "不能选择相同的机位",
      gouxuanZm: "勾选后，首次添加字幕会出现在PVW画面中，并且字幕会跟随PVW移动",
      notgouxuanZm: "不勾选，字幕会同时出现在PVW和PGM画面中",
    },
    // 素材管理 materiallist
    material:{
      materialMng: "素材管理",
      imgMng: "图片管理",
      addImg: "添加图片",
      size: "尺寸",
      uploadDate: "上传日期",
      sckNoImg: "图片素材为空，快去添加吧～",
      delImgSc: "删除图片成功",
      isSureDelImg: "你确认要删除图片吗",
      imgUploadSc: "上传图片成功",
      fileUploadFail: "上传文件失败",
      imgTypeErr: "上传图片格式有误，请重新上传",
    },
    // 画面拼接 mosaicList
    mosaic:{
      roomName: "房间名称",
      pjType: "拼接模式",
      rwStatus: "任务状态",
      syTime: "剩余时长",
      serviceOpen: "服务开启",
      look: "查看",
      pinjie: "拼接",
      toCreateRw: "暂未创建任务，快去新建哟～",
      rwList: "单任务",
      jilian: "级联",
      hechenging: "合成中",
      enabled: "已启用",
      stopSynthesis: "合成停止",
      isSureDelRw: "你确认要删除该条任务吗",
      stopSc: "停用成功",
      isSureStopRw: "确认停用该任务吗",

      plsInpName: "请输入名称",
      refresh: "刷新",
      addTime: "添加时长",
      goOut: "退出",
      noHcxh: "暂无合成信号",
      addTimes: "增加时长",
      chooseTimes: "选择时长",
      oneMinite: "1分钟拼接服务消耗1G直播流量",
      plsSureTime: "请保证时长充足",
      pjtip1: "拼接服务采取先使用后付费的形式，若提前结束，则只按照使用的时长扣费，",
      pjtip2: "当服务时长用完，系统会赠送您15分钟，过时会自动关闭，请务必保证时长余量充足；创建后开始计费。",
      goOutTip: "退出提示",
      closeNeedOpen: "关闭后将停止拼接服务，剩余的时长不会产生计费，再次使用需要重新开启。",
      canUseTimeTt: "可用时长不足30分钟，请及时新增时长",
      canUseTimeTen: "可用时长不足10分钟，请及时新增时长",
      balanceAndRecharge: "您的余额已不足，将免费赠送您15分钟，请及时充值",
      serviceDisabled: "服务已停用",
      renewalSc: "续费成功",
      notPay: "服务已停止，无法正常充值",
      // operateMosaicModal
      rwName: "任务名称",
      Splicing: "拼接",
      synthesis: "合成",
      reFreshSc: "刷新成功",
      minOneCy: "至少选择一位成员",
      minTwoCy: "只能选择两位成员切换",
      hccybcg: "合成成员不能超过",
      ge: "个",
      hcSc: "合成成功",
      // creatMosaicModal
      newRw: "新建任务",
      openRw: "开启任务",
      pjTemp: "拼接模板",
      chooseRoom: "选择房间",
      chooseTime: "选择时长",
      plsChooseTemp: "请选择模板",
      plsCHooseRoom: "请选择房间",
      // js
      enterRoomErr: "进房失败原因",
      sysErr: "系统错误",

      mobanManage: "模板管理",
      roomType: "房间类型",
      chooseMb: "选择模板",
      pjhmAddRoom: "拼接画面加入房间",
      ydbTip11: "画面拼接按照运行分钟数扣费，采取先使用后付费的形式",
      ydbTip22: "若导播提前结束，则只按照使用的时长扣费",
      beginSc: "开启成功",
      pjSet: "拼接设置",
      roomList: "房间成员列表",
      cyName: "成员昵称",
      chuangPosition: "窗口位置",
      kong: "空",
      sxList: "刷新列表",
      autoTcck: "自动填充窗口",
      clearCk: "清空全部窗口",
      pstNotCf: "窗口位置不能重复，请重新选择",
      ckMax32: "窗口不能超过32个",
      plsAddCk: "请添加窗口",
    },
  },
  // user 用户中心
  user:{
      goOut: "退出",
      gotoKzt: "返回控制台",
      userCenter: "用户中心",
      zhInfo: "账号信息",
      zzhMng: "子租户管理",
      userMng: "用户管理",
      roleMng: "角色管理",
      loginZh: "登录账号",
      userNc: "用户昵称",
      none: "无",
      userId: "用户ID",
      tenant: "所属租户",
      tenantId: "租户ID",
      role: "角色",
      userKey: "用户KEY",
      slPh: "关联手机",
      userEmil: "用户邮箱",
      changePhNumber: "更改手机号",
      authentication: "验证身份",
      changePh: "更改手机",
      yzPass: "验证密码",
      inputPass: "请输入密码",
      newPhNumber: "新手机号",
      inputPhNumber: "请输入手机号",
      dxYz: "短信验证",
      plsInputYzm: "请输入验证码",
      getYzm: "获取验证码",
      reGet: "后重新获取",
      yanzheng: "验证",
      inputLoginPass: "请输入登录密码",
      passErr: "密码不正确",
      sendYzmSc: "验证码发送成功",
      editSc: "修改成功",
      inputYhNc: "请输入用户昵称",
      plsIptEmil: "请输入邮箱",
      editUserNc: "修改用户昵称",
      editUserEmil: "修改用户邮箱",
      plsIptRightEmailAds: "请输入正确的邮箱地址",
      zzhTree: "子租户树状结构",
      zzhInfo: "子租户信息",
      plsIptKeywordToSearch: "请输入名称或ID等关键字搜索",
      qianfeiTip: "当前的子租户存在欠费情况，如需删除，已欠费的额度将会从您的套餐中扣除",
      isSureDelZzh: "你确认要删除该子租户吗",
      isJxcz: "删除该子租户后，其下仍有分配的流量会返还给父租户，是否继续操作",
      begin_endTime: "开始日期 ~ 结束日期",
      topFatherTenant: "顶级父租户",
      fped: "分配额度",
      user: "用户",
      tenantName: "租户名称",
      plsIptTenantName: "请输入租户名称",
      childTenantId: "子租户ID",
      childTanantName: "子租户名称",
      hasUsers: "拥有用户数",
      lastEditTime: "最后编辑时间",
      tip: "提示",
      contentNotSave: "编辑内容未保存,是否继续操作",
      nopackage: "暂无套餐",
      tenantRemain: "父租户剩余",
      childTenantOwne: "子租户拥有",
      distribution: "分配",
      packageTYpechange: "套餐消耗类型已经被修改为顶级父租户模式",
      packageChoose: "套餐选择",
      add: "增加",
      reduce: "减少",
      distributionMinOne: "分配不能小于1",
      nogreaterThanRemain: "分配不能大于父租户剩余",
      nogreaterThanOwne: "分配不能大于子租户拥有",
      distributionSc: "分配成功",
      newRemain: "当前剩余",
      nokown: "未知",
      day: "天",
      tpqftc: "填平欠费套餐",
      IKown: "我知道了",
      arrearageContent: "欠费内容",
      total: "总计",
      deductionPackage: "扣除套餐",
      nextStep: "下一步",
      lastStep: "上一步",
      confirmRepayment: "确认偿还",
      manage: "管理",
      packageType: "套餐消耗类型",
      packageContent: "套餐内容",
      childTenantQf: "当前的子租户存在欠费情况，已欠费的额度将会从您的套餐中扣除",
      childTenantHasLl: "当前子租户下未消耗完的流量,将会返还给父租户,是否继续操作",
      packageChangeAndshfp: "套餐消耗类型切换为'分配额度'后,需要手动对套餐内容进行分配,是否继续操作",
      batchAdd: "批量添加",
      ssTenantName: "所属租户名称",
      file: "文件",
      uploadFile: "上传excel文件",
      uploadSm: "上传说明",
      clickToDownloadTemp: "点击此处下载模板",
      inputContent: "并按照表格内容填写",
      uploadTempOnThere: "将填写好的模板在此处上传",
      fileMaxTt: "文件不能超过20M",
      plsUploadFile: "请上传文件",
      importResult: "导入结果",
      success: "成功",
      fail: "失败",
      strip: "条",
      errLine: "错误行数",
      errMsg: "错误信息",
      newChildTenant: "新建子租户",
      plsIptName: "请输入名称",
      nameNotNull: "名称不能为空",
      move: "移动",
      qfTip2: "当前的子租户存在欠费情况，如需移动，已欠费的额度将会从您的套餐中扣除",
      plsChooseATenant: "请选择一个租户",
      hasAndMove: "已存在所选租户下，请选择其他租户后移动",
      sureMove: "移动确认",
      isSureMoveCdTenant: "你确认要移动该子租户吗",
      moveAndFhgprt: "移动该子租户后，其下仍有分配的流量会返还给父租户，是否继续操作",
      moveSc: "移动成功",
      userList: "用户列表",
      userName: "用户名称",
      userRole: "用户角色",
      noData: "暂无数据",
      plsChoose: "请选择",
      plsInputRoleName: "请输入角色名称搜索",
      newRole: "新建角色",
      fpqx: "分配权限",
      roleName: "角色名称",
      createTime: "创建时间",
      roleList: "角色列表",
      deled: "已删除",
      jurisdiction: "权限",
      distributioned: "已分配",
      createRole: "创建角色",
      editRole: "编辑角色",
      name: "名称",
      createSc: "创建成功",
      importRole: "导入角色",
      importSjzhList: "为了方便您的管理，您可以导入您的上级租户所创建的角色列表，具体如下",
      reporter: "记者",
      importNow: "现在导入",
      plsIptNmOrNc: "请输入用户名或昵称等关键字搜索",
      changeRole: "更改角色",
      nickname: "昵称",
      ssRole: "所属角色",
      phoneNumber: "手机号码",
      delFail: "删除失败",
      isSureDelUser: "您确认要删除该用户吗",
      plsChooseUser: "请选择用户",
      plsChooseOneTypeUser: "请选择同一租户下的用户",
      addUser: "新增用户",
      zhanghao: "账号",
      plsIptRule: "请输入用户名，最多50个字符，建议英文或数字",
      password: "密码",
      passRule: "至少8位，必须包含大小写字母，数字，特殊字符",
      surePass: "确认密码",
      plsSurePass: "确保两次输入完全一致",
      maxTtText: "最多20个字符",
      phone: "手机",
      inputPhNum: "输入手机号码",
      email: "邮箱",
      inputEmailAds: "输入邮箱地址",
      plsIptUsername: "请输入用户名",
      plsIptNickname: "请输入昵称",
      plsReIptPass: "请再次输入密码",
      plsChooseTenant: "请选择租户",
      getRolelistFail: "获取角色列表失败",
      passRule1: "密码至少8位,必须包含大小写字母，数字和特殊符号",
      passRule2: "两次密码输入不一致，请重新输入",
      plsIptRightPh: "请输入正确的手机号",
      batchImport: "批量导入",
      chooseTenant: "选择租户",
      uploadFail: "上传文件",
      fileSizeMaxTen: "文件不能超过10M",

  },
  // sportlive 赛事直播
  sportlive:{
    sportlive: "赛事直播",
    // sportliveList
    newChannel: "新建频道",
    schedule: "赛程单",
    programGuides: "节目单",
    monitor: "监控",
    noTvToNew: "暂无电视频道，快去新建吧～",
    isSureDelProgram: "你确认要删除该节目吗",
    // sportliveEditModal
    editChannel: "编辑频道",
    eventName: "赛事名称",
    plsIptName: "请输入名称，20字以内",
    activityTime: "活动时间",
    normalDate: "yyyy年MM月dd日",
    plsChooseBeginEndTime: "请选择起止日期",
    cover: "封面",
    uploadImg: "上传图片",
    requirement: "要求",
    imgType: "格式为png、jpg、gif等",
    delCover: "删除封面",
    plsIptBz: "请输入赛事备注，50字以内",
    plsIptPdname: "请输入频道名称",
    twoToTt: "2到20个字符",
    plsChooseCover: "请选择封面",
    maxFt: "不能超过50个字符",
    uploadImgSc: "上传图片成功",
    uploadFileFail: "上传文件失败",
    uploadSizeMax: "上传图片不能超过3M",
    uploadImgErr: "上传图片格式有误，请重新上传",
    remarks: "备注",
    // schedule
    chooseDate: "选择日期",
    downTemp: "下载导入模板",
    importSchedule: "导入赛程单",
    exportSchedule: "导出赛程单",
    list: "列表",
    timeList: "时间表",
    addTime: "添加项目",
    openScreen: "打开大屏",
    channel_time: "通道/时间",
    HD: "高清",
    projectName: "项目名称",
    signalType: "信号格式",
    field: "场地",
    status: "状态",
    projectFl: "项目分类",
    open_close: "开启/关闭",
    address: "地址",
    noData: "暂无数据",
    noinput: "暂无输入",
    monday: "周一",
    tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    Saturday: "周六",
    Sunday: "周日",
    noLiveStream: "无直播流",
    living: "直播中",
    closed: "已关闭",
    ended: "已结束",
    notBegin: "未开始",
    noKown: "未知",
    publicEvents: "公共赛事",
    minorityEvent: "小众赛事",
    openChannel: "开启通道成功",
    closeChannel: "关闭通道成功",
    cancelEdit: "操作已取消",
    isSureOpenChannel: "确认开启通道吗",
    isSureCloseChannel: "确认关闭通道吗",
    editSure: "操作确认",
    fileSizemaxTt: "文件不能超过30M",
    importSc: "导入成功",
    ssjmd: "赛事节目单",
    // conflictModal
    importErr: "导入错误",
    jmTimeConflict: "节目单导入失败！您的节目单中以下节目时间冲突，请您修改后重试导入",
    jmNeedEdit: "节目单导入失败！请您修改后重试导入",
    wrongLocation: "错误定位",
    wrongInfo: "错误信息",
    // scheduleEditModal
    newProgram: "新建节目",
    editProgram: "编辑节目",
    plsIptProgramName: "请输入项目名称，50字以内",
    plsChooseTime: "请选择时间",
    plsIptPID: "请输入PID，50字以内",
    signalFormat: "信号格式",
    gqSRT: "高清SRT",
    xmType: "项目分类",
    plsIptType: "请输入项目分类，50字以内",
    bscd: "比赛场地",
    plsIptBscd: "请输入比赛场地，50字以内",
    dzInfo: "对阵信息",
    plsIptDdxx: "请输入对阵信息，50字以内",
    xmBeizhu: "项目备注",
    plsIptXmbz: "请输入项目备注",
    plsXmname: "请输入项目名称",
    chooseBgt: "请选择开始时间",
    chooseEdt: "请选择结束时间",
    iptPID: "请输入PID",
    plsIptXmfl: "请输入项目分类",
    iptBscd: "请输入比赛场地",
    iptDzxx: "请输入对阵信息",
    // streamAddressModal
    playAddress: "播放地址",
    channelAddress: "通道地址",
    pushAddress: "推流地址",
    sourceCode: "源码",
    // monitorModal
    channelJk: "通道监控",
    pushData: "推流数据",
    liveData: "直播记录",
    // LiveRecord
    today: "今天",
    yesterday: "昨天",
    beforeYesterday: "前天",
    begin_endTime: "开始时间~结束时间",
    searchTtData: "可查询最近60天，查询时间段小于30天的数据。",
    pushTimes: "推流时长",
    pushIp: "推流客户端IP",
    pushFbl: "推流分辨率",
    stopReason: "停止推流原因",
    maxTyDay: "查询时间段不能超过30天",
    // StreamData
    maxSixHour: "查询时间段不能超过6小时",
    // ChartPart
    VideoFps: "视频帧率",
    VideoRate: "视频码率",
    AudioFps: "音频帧率",
    AudioRate: "音频码率",
    nowNotPush: "此时间段未推流",
    Company: "单位",
    // mix4program.js
    // scheduleBigscreen
    cloudChannelList: "云分发通道编排单",
    // scheduleInfoModal
    jmxq: "节目详情",
    plsIptKeyword: "请输入关键字",
    exportJmd: "导出节目单",
    noJmd: "暂无节目单"
  },

  //连线成员管理列表
  connM:{
    stickTop:'置顶',
    cancleTop:'取消置顶',
    hide:'隐藏',
    show:'取消隐藏',
    feedback:'返送盒子',
    cancelFeedback:'取消返送',
    mute:'禁言',
    unmute:'取消禁言',
    all:'全部',
    nickname:'昵称',
    host:'主播',
    hangUp:'挂断',
    jieru:'接入',
    living:'连线中',
    waitJoin:'正在接入',
    leaved:'已离开',
    status:'状态',

    spfgx: "竖屏分割线",
    fullScreen: "全屏",
    volume: "音量",
    tlFail: "推流失败",
    sxtwffw: "摄像头无法访问",
    mkfwffw: "麦克风无法访问",
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/i18n/langs/zh.js